/**
 * Extract spec-source-only fields from a prior `.canary.md` file the CLI
 * is about to overwrite. The live workflow row has no column for these, so
 * pulling without preservation would silently drop them on re-pull.
 *
 * Lifted as a tiny standalone parser to avoid pulling the full `parseSpec`
 * machinery (with its lint pass) just to read two fields.
 */
export function extractPreservedFrontmatter(priorSource: string): {
  requirementRef?: string;
  preserveScenarioSkipReasons?: Record<string, string>;
} {
  const result: {
    requirementRef?: string;
    preserveScenarioSkipReasons?: Record<string, string>;
  } = {};

  // Frontmatter: a single `requirementRef:` key (top-level, no nesting).
  const fmMatch = priorSource.match(/^---\n([\s\S]*?)\n---/);
  if (fmMatch) {
    const reqMatch = fmMatch[1].match(/^requirementRef:\s*(.+)$/m);
    if (reqMatch) {
      const raw = reqMatch[1].trim();
      // Strip wrapping quotes (yamlScalar produces JSON.stringify for ambiguous values).
      const unquoted = raw.startsWith('"') && raw.endsWith('"') ? JSON.parse(raw) : raw;
      result.requirementRef = unquoted;
    }
  }

  // Scenarios: lift any `### <name> *(skip: <reason>)*` heading.
  const skipReasons: Record<string, string> = {};
  const re = /^###\s+(.+?)\s+\*\(skip:\s*(.+?)\)\*\s*$/gm;
  let m: RegExpExecArray | null;
  while ((m = re.exec(priorSource)) !== null) {
    const name = m[1].trim();
    const reason = m[2].trim();
    if (name && reason) skipReasons[name] = reason;
  }
  if (Object.keys(skipReasons).length > 0) {
    result.preserveScenarioSkipReasons = skipReasons;
  }

  return result;
}
